// Module
var code = "<span class=\"date-time\" :data-timestamp=\"timestamp\">{{ formatted }}</span> ";
// Exports
export default code;